import { c as _c } from "react/compiler-runtime";
import { cn } from '@newfront-insurance/core-ui/v2';
import type { ComponentProps, PropsWithChildren, JSX } from 'react';
export function ToolbarButton(t0) {
  const $ = _c(7);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("text-steel-400 hover:bg-steel-100 focus:bg-steel-100 data-[active=true]:bg-steel-100 dark:text-foreground dark:hover:bg-brand-400 dark:focus:bg-brand-400", "flex h-10 w-10 items-center justify-center rounded-full indent-[-9999px] transition-all duration-200 ease-in-out hover:cursor-pointer focus:outline-hidden");
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== props) {
    t2 = <a className={t1} {...props}>{children}</a>;
    $[4] = children;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}